import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "bg-gray-800 p-4 rounded-lg mb-6" }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-4" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "flex justify-end space-x-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CategoryDropdown = _resolveComponent("CategoryDropdown")!
  const _component_CityDropdown = _resolveComponent("CityDropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _cache[8] || (_cache[8] = _createElementVNode("label", {
          for: "search",
          class: "block text-sm font-medium text-gray-300 mb-1"
        }, "Pretraga po imenu", -1)),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          id: "search",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.search) = $event)),
          placeholder: "Unesite ime proizvoda...",
          class: "w-full bg-gray-700 border border-gray-600 rounded-md py-2 px-3 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-green-500",
          onKeydown: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)), ["enter"])),
          autocomplete: "off"
        }, null, 544), [
          [_vModelText, _ctx.filters.search]
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_CategoryDropdown, {
          modelValue: _ctx.filters.categoryId,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.categoryId) = $event))
        }, null, 8, ["modelValue"]),
        (!_ctx.hideFields.includes('city'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_CityDropdown, {
                id: "city-search",
                modelValue: _ctx.filters.city,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.city) = $event)),
                label: "Mesto",
                placeholder: "Pretraži gradove..."
              }, null, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _cache[9] || (_cache[9] = _createElementVNode("label", {
            for: "minPrice",
            class: "block text-sm font-medium text-gray-300 mb-1"
          }, "Min. cena", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "number",
            id: "minPrice",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.minPrice) = $event)),
            min: "0",
            placeholder: "Min. cena",
            class: "w-full bg-gray-700 border border-gray-600 rounded-md py-2 px-3 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-green-500",
            autocomplete: "off"
          }, null, 512), [
            [
              _vModelText,
              _ctx.filters.minPrice,
              void 0,
              { number: true }
            ]
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[10] || (_cache[10] = _createElementVNode("label", {
            for: "maxPrice",
            class: "block text-sm font-medium text-gray-300 mb-1"
          }, "Max. cena", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "number",
            id: "maxPrice",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters.maxPrice) = $event)),
            min: "0",
            placeholder: "Max. cena",
            class: "w-full bg-gray-700 border border-gray-600 rounded-md py-2 px-3 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-green-500",
            autocomplete: "off"
          }, null, 512), [
            [
              _vModelText,
              _ctx.filters.maxPrice,
              void 0,
              { number: true }
            ]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.resetFilters && _ctx.resetFilters(...args))),
          class: "px-4 py-2 bg-gray-700 hover:bg-gray-600 text-gray-300 rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-gray-500"
        }, " Obriši filtere "),
        _cache[11] || (_cache[11] = _createElementVNode("button", {
          type: "submit",
          class: "px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-green-500"
        }, " Pretraži ", -1))
      ])
    ], 32)
  ]))
}